(function(a) { a.fn.prepareTransition = function() { return this.each(function() { var b = a(this);
            b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() { b.removeClass("is-transitioning") }); var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"]; var d = 0;
            a.each(c, function(a, c) { d = parseFloat(b.css(c)) || d }); if (d != 0) { b.addClass("is-transitioning");
                b[0].offsetWidth } }) } })(jQuery);

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = (format || this.money_format);

        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
}

// mono functions
window.mono = window.mono || {};

mono.cacheSelectors = function() {
    mono.cache = {
        // General
        $html: $('html'),
        $body: $(document.body)
    };
};

mono.init = function() {
    mono.cacheSelectors();
    if (!$('body').hasClass('template-cart')) {
        mono.drawersInit();
    }
};

mono.drawersInit = function() {
    mono.RightDrawer = new mono.Drawers('CartDrawer', 'right', {
        'onDrawerOpen': ajaxCart.load
    });
};

mono.getHash = function() {
    return window.location.hash;
};

/*============================================================================
  Drawer modules
==============================================================================*/
mono.Drawers = (function() {
    var Drawer = function(id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };

        this.$nodes = {
            parent: $('body, html'),
            page: $('#PageContainer'),
            moved: $('.is-moved-by-drawer')
        };

        this.config = $.extend(defaults, options);
        this.position = position;

        this.$drawer = $('#' + id);

        if (!this.$drawer.length) {
            return false;
        }

        this.drawerIsOpen = false;
        this.init();
    };

    Drawer.prototype.init = function() {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
    };

    Drawer.prototype.open = function(evt) {
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to $nodes.page
        // which closes the drawer.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }

        // Notify the drawer is going to open
        mono.cache.$body.trigger('beforeDrawerOpen.mono', this);

        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        this.$nodes.moved.addClass('is-transitioning');
        this.$drawer.prepareTransition();

        this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = true;

        // Set focus on drawer
        this.trapFocus(this.$drawer, 'drawer_focus');

        // Run function when draw opens if set
        if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
            var currency = localStorage.getItem('currency') || Shopify.currency.active;

            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true');
        }

        // Lock scrolling on mobile
        this.$nodes.page.on('touchmove.drawer', function() {
            return false;
        });

        this.$nodes.page.on('click.drawer', $.proxy(function() {
            this.close();
            return false;
        }, this));

        // Notify the drawer has opened
        mono.cache.$body.trigger('afterDrawerOpen.mono', this);
    };

    Drawer.prototype.close = function() {
        if (!this.drawerIsOpen) { // don't close a closed drawer
            return;
        }

        // Notify the drawer is going to close
        mono.cache.$body.trigger('beforeDrawerClose.mono', this);

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        // Ensure closing transition is applied to moved elements, like the nav
        this.$nodes.moved.prepareTransition({ disableExisting: true });
        this.$drawer.prepareTransition({ disableExisting: true });

        this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

        this.drawerIsOpen = false;

        // Remove focus on drawer
        this.removeTrapFocus(this.$drawer, 'drawer_focus');

        this.$nodes.page.off('.drawer');

        // Notify the drawer is closed now
        mono.cache.$body.trigger('afterDrawerClose.mono', this);
    };

    Drawer.prototype.trapFocus = function($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

        $container.attr('tabindex', '-1');

        $container.focus();

        $(document).on(eventName, function(evt) {
            if ($container[0] !== evt.target && !$container.has(evt.target).length) {
                $container.focus();
            }
        });
    };

    Drawer.prototype.removeTrapFocus = function($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

        $container.removeAttr('tabindex');
        $(document).off(eventName);
    };

    return Drawer;
})();

// Initialize mono's JS on docready
$(mono.init);

$('body').on('click', '#upsell', function() {
    var prId = $(this).find('input').val();
    $('#upsell_form input').val(prId);
});

function toggleAccordion(el) {
  var accordion = el.closest('.cart-drawer-accordion');
  if (!accordion) return;
  var isOpen = accordion.classList.contains('is-open');
  document.querySelectorAll('.cart-drawer-accordion.is-open').forEach(function(a) {
    a.classList.remove('is-open');
  });
  if (!isOpen) accordion.classList.add('is-open');
}

(function() {
  var el = null, startX = 0, scrollLeft = 0, moved = false;

  document.addEventListener('mousedown', function(e) {
    var t = e.target.closest('.gift-cards-options-wrapper');
    if (!t) return;
    el = t;
    startX = e.clientX;
    scrollLeft = t.scrollLeft;
    moved = false;
    t.style.userSelect = 'none';
  });

  document.addEventListener('mousemove', function(e) {
    if (!el) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 3) moved = true;
    if (moved) el.scrollLeft = scrollLeft - dx;
  });

  document.addEventListener('mouseup', function() {
    if (el) el.style.userSelect = '';
    el = null;
  });

  document.addEventListener('wheel', function(e) {
    var t = e.target.closest('.gift-cards-options-wrapper');
    if (!t) return;
    e.preventDefault();
    t.scrollLeft += e.deltaY || e.deltaX;
  }, { passive: false });
})();
